import { Base } from '@studiometa/js-toolkit';

/**
 * @typedef {{
 *   $refs: {
 *    burger: HTMLButtonElement,
 *    }
 * }} HeaderProps
 */

/**
 * @extends {Base<HeaderProps>}
 * Header class
 */
export default class Header extends Base {
  /**
   * Class config
   */
  static config = {
    name: 'Header',
    refs: ['burger'],
  };

  menuIsOpen = false;

  /**
   * On burgerClick
   */
  onBurgerClick() {
    if (this.menuIsOpen) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }

  /**
   * Toggle the menu class
   * @param {boolean} open
   */
  toggleMenu(open = false) {
    this.menuIsOpen = open;
    document.body.classList[open ? 'add' : 'remove']('menu-is-open');
  }

  /**
   * Open menu
   */
  openMenu() {
    this.toggleMenu(true);
  }

  /**
   * Close menu
   */
  closeMenu() {
    this.toggleMenu(false);
  }
}
